export const SET_KEY = 'src/scratch/SET_KEY' as const;

export const DELETE_KEY = 'src/scratch/DELETE_KEY' as const;
